import React, { useState, useEffect } from 'react';
import LVCuadricula from '../Compuestos/Complejos/Generales/LVCuadricula';
import { function_VEN_Reservas_Cabecera_Leer } from 'neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera';

function LVSelectorPorcentaje({ onSelectedCodigoChange, idReserva }) {
  const [dataASeleccionar, setDataASeleccionar] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [resultReserva, setResultReserva] = useState([]);

  useEffect(() => {
    const fetchGrupos = async () => {
      setLoadingData(true);
      try {
        const resultReservaParcial = await function_VEN_Reservas_Cabecera_Leer(idReserva)

        if (!resultReservaParcial || !resultReservaParcial.data || resultReservaParcial.data.length < 1) {
          alert("La Reserva no existe.");
          handleCancelStrong()
        }

        setResultReserva(resultReservaParcial)
      } catch (error) {
        alert("Error al obtener los datos:" + error);
      } finally {
        setLoadingData(false); // Asegúrate de que se llame siempre
      }
    };

    fetchGrupos();
  }, []);

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        if (resultReserva.data.PorcentajeFacturado >= 100) {
          alert("La Reserva se encuentra completamente facturada.");
          const respuesta = window.confirm("¿Desea realizar una NC?");

          if (respuesta) {
            // El usuario eligió "SI"
            handleCancelPorNC()
          } else {
            handleCancel()
          }          
        }

        let opcionesBase = [
          { Cantidad: 0.25, Descripcion: "25%" },
          { Cantidad: 0.3, Descripcion: "30%" },
          { Cantidad: 0.5, Descripcion: "50%" },
          { Cantidad: 0.7, Descripcion: "70%" },
          { Cantidad: 0.75, Descripcion: "75%" },
          { Cantidad: 1, Descripcion: "100%" }
        ];

        if (localStorage.getItem("CodigoCompania") === "302") {
          opcionesBase = [
            { Cantidad: 0.5, Descripcion: "50%" },
            { Cantidad: 1, Descripcion: "100%" }
          ];
        }

        if (!resultReserva.data.EsEvento) {
          opcionesBase = [
            { Cantidad: 1, Descripcion: "100%" }
          ];
        }

        const porcentajeActual = resultReserva.data.PorcentajeFacturado ?? 0;
        let porcentajeRestante = 100 - porcentajeActual;
        porcentajeRestante = porcentajeRestante / 100

        const opcionesFiltradas = opcionesBase
          .filter(op => op.Cantidad <= porcentajeRestante && op.Cantidad + ((Number(porcentajeActual) || 0) / 100) <= 1)
          .map(item => ({
            ...item,
            Habilitado: true,
            Color: -14330269
          }));

        setDataASeleccionar(opcionesFiltradas);

        // 👇 Auto-selección si hay una sola opción
        if (opcionesFiltradas.length === 1) {
          const unica = opcionesFiltradas[0];
          if (onSelectedCodigoChange) {
            onSelectedCodigoChange(unica.Cantidad, unica.Descripcion, resultReserva);
          }
        }
      } catch (error) {
        throw error
      } finally {
        setLoadingData(false); // Asegúrate de que se llame siempre
      }
    };

    fetchGrupos();
  }, [resultReserva]);

  const handleSelectorClick = async (codigo, descripcion) => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange(codigo, descripcion, resultReserva);
    }
  };

  const handleCancel = () => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange("", "");
    }
  };

  const handleCancelPorNC = () => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange("NC", "", resultReserva);
    }
  };

  const handleCancelStrong = () => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange("-1", "");
    }
  };

  return (

    <div className="LV-Selectores-div">
      <table >
        <tbody>
          <tr>
            <td>
              <LVCuadricula
                data={dataASeleccionar}
                IdGrupo={0}
                CantidadDeBotonesHorizontal={6}
                AltoBotones={70}
                AnchoBotones={70}
                CampoCodigo={"Cantidad"}
                CampoDescripcion={"Descripcion"}
                onButtonClick={handleSelectorClick}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorPorcentaje;